/**
 * Links a react-hook-form field to its error message for screen readers —
 * `aria-invalid` plus `aria-describedby` pointing at the error's id.
 * `role="alert"` on the error element alone announces it once when it
 * first appears, but doesn't give the field a persistent accessible
 * description a screen reader user can find later (§10.6).
 */
export function errorAria(errors, field) {
  const hasError = Boolean(errors[field]);
  return {
    "aria-invalid": hasError,
    "aria-describedby": hasError ? `${field}-error` : undefined,
  };
}
